import LocalizedStrings from "react-localization";

let loginStrings = new LocalizedStrings({
    en: {
        loginSelectionText: "Log In",
        signUpSelectionText: "Sign Up",
        requiredFieldString: "All fields marked with a \u2731 are required.",
        usernameFieldText: "Username\u2731",
        usernameButtonText: "Check DisplayName",
        emailFieldText: "Email\u2731",
        passwordFieldText: "Password\u2731",
        passwordLengthCheck: "Password must be at least 8 characters",
        passwordLowerCaseCheck: "Password must have a lowercase letter",
        passwordUpperCaseCheck: "Password must have a capital letter",
        passwordSpecialCharCheck: "Password must have a special character",
        passwordNumberCheck: "Password must have a number",
        confirmPasswordFieldCheck: "Confirm Password\u2731",
        matchPasswordCheck: "Passwords Must Match",
        dateOfBirthFieldText: "Date of Birth\u2731",
        parentalEmailFieldText: "Parental Email\u2731",
        tosCheckText: "I agree to the {0} \u2731",
        tosLinkText: "Ludare Terms of Service.",
        marketingCheckText: "I am interested in recieving special deals and news from Ludare.",
        usernameLoginFieldText: "Username:",
        passwordLoginFieldText: "Password:",
        forgotPasswordLinkText: "Forgot Password",
        loginButtonText: "Log In"
    },
});

export default loginStrings;